var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18.667c.736 0 1.333.597 1.333 1.333v5.333a1.333 1.333 0 0 0 1.334 1.334h18.666a1.333 1.333 0 0 0 1.334-1.334V20a1.333 1.333 0 0 1 2.666 0v5.333a4 4 0 0 1-4 4H7.167a4 4 0 0 1-4-4V20c0-.736.597-1.333 1.333-1.333",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89 12.39c.521-.52 1.365-.52 1.886 0l5.724 5.724 5.724-5.724a1.333 1.333 0 1 1 1.886 1.886l-6.667 6.667c-.52.52-1.365.52-1.886 0l-6.666-6.667a1.333 1.333 0 0 1 0-1.886",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2.667c.736 0 1.333.597 1.333 1.333v16a1.333 1.333 0 1 1-2.666 0V4c0-.736.597-1.333 1.333-1.333",
    clipRule: "evenodd"
  })));
};
export default SvgDownload;